import { render, staticRenderFns } from "./DistrictSchoolField.vue?vue&type=template&id=223a1575&"
import script from "./DistrictSchoolField.vue?vue&type=script&lang=js&"
export * from "./DistrictSchoolField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports